export class MoveEventsCargoOperation {
    constructor(fromCargoOperationId: number, toCargoOperationId: number) {
        this.fromCargoOperationId = fromCargoOperationId;
        this.toCargoOperationId = toCargoOperationId;
    }
    fromCargoOperationId: number;
    toCargoOperationId: number;
}
